import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, TextField, CircularProgress, Tooltip } from '@mui/material';
import axios from 'axios';

// Генерируем слоты по 30 минут с 8:00 до 22:00
const SLOTS = Array.from({ length: 28 }, (_, i) => {
  const totalMinutes = (8 * 60) + (i * 30);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return { 
    label: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`,
    minutes: totalMinutes 
  };
});

const AvailabilityGantt: React.FC = () => {
  const [date, setDate] = useState<string>(new Date().toISOString().split('T')[0]);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.get(`/api/guide-availability/matrix/${date}`)
      .then(res => setData(res.data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [date]);

  const isTimeAvailable = (guide: any, slotMinutes: number) => {
    if (!guide.isAvailable || !guide.shifts || guide.shifts.length === 0) return false;
    
    return guide.shifts.some((shift: any) => {
      if (!shift.from || !shift.to) return false;
      
      // Переводим "10:00" в минуты (600)
      const [fromH, fromM] = shift.from.split(':').map(Number);
      const [toH, toM] = shift.to.split(':').map(Number);
      
      const fromMins = fromH * 60 + (fromM || 0);
      const toMins = toH * 60 + (toM || 0);
      
      return slotMinutes >= fromMins && slotMinutes < toMins;
    });
  };

  return (
    <Paper sx={{ p: 2, mb: 3, borderRadius: 2, border: '1px solid #e0e0e0', boxShadow: 'none' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        
        <TextField
          type="date"
          size="small"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          sx={{ width: 180 }}
        />
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress /></Box>
      ) : (
        <Box sx={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 1200 }}>
            <thead>
              <tr>
                <th style={{ padding: '12px 8px', textAlign: 'left', borderBottom: '2px solid #e0e0e0', minWidth: 150, color: '#666', position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>Экскурсовод</th>
                {SLOTS.map((slot, idx) => (
                  <th key={idx} style={{ 
                    padding: '4px 2px', 
                    textAlign: 'center', 
                    borderBottom: '2px solid #e0e0e0', 
                    fontSize: '11px', 
                    color: '#666', 
                    width: '30px',
                    borderLeft: slot.minutes % 60 === 0 ? '1px solid #ccc' : '1px solid #f5f5f5' 
                  }}>
                    {slot.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((guide, idx) => (
                <tr key={guide.id} style={{ backgroundColor: idx % 2 === 0 ? '#fafafa' : 'white' }}>
                  <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', fontWeight: 500, fontSize: '14px', color: '#333', position: 'sticky', left: 0, backgroundColor: idx % 2 === 0 ? '#fafafa' : 'white', zIndex: 1 }}>
                    {guide.name}
                  </td>
                  {SLOTS.map((slot, sIdx) => {
                    const available = isTimeAvailable(guide, slot.minutes);
                    return (
                      <td key={sIdx} style={{ padding: '6px 2px', borderBottom: '1px solid #eee', borderLeft: slot.minutes % 60 === 0 ? '1px solid #ccc' : '1px solid #f5f5f5' }}>
                        <Tooltip title={`${guide.name} ${available ? 'доступен' : 'недоступен'} в ${slot.label}`}>
                          <div style={{
                            width: '100%',
                            height: '24px',
                            borderRadius: '2px',
                            backgroundColor: available ? '#4caf50' : '#f0f0f0',
                            opacity: available ? 0.9 : 1,
                          }} />
                        </Tooltip>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      )}
    </Paper>
  );
};

export default AvailabilityGantt;
